import { render, staticRenderFns } from "./ConfirmationComponent.vue?vue&type=template&id=65d7803d&scoped=true"
import script from "./ConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmationComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationComponent.vue?vue&type=style&index=0&id=65d7803d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d7803d",
  null
  
)

export default component.exports